import {charcoal} from '~libSass/base/_exports.sass';

export const StickerUploadIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 40;
  const height = 40;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Sticker Upload Icon"
    >
      <rect fill={color} y="14.98" width="1.08" height="9.73" />
      <path
        fill={color}
        d="M1.08,35.14v-5.45H0v5.45c0,2.68,2.18,4.86,4.86,4.86h5.37v-1.08h-5.37c-2.09,0-3.78-1.7-3.78-3.78Z"
      />
      <rect fill={color} x="14.81" y="38.92" width="9.73" height="1.08" />
      <path
        fill={color}
        d="M38.92,35.14c0,2.09-1.7,3.78-3.78,3.78h-5.46v1.08h5.46c2.68,0,4.86-2.18,4.86-4.86v-5.5h-1.08v5.5Z"
      />
      <rect fill={color} x="38.92" y="14.98" width="1.08" height="9.73" />
      <path
        fill={color}
        d="M35.14,0h-5.46v1.08h5.46c2.09,0,3.78,1.7,3.78,3.78v5.34h1.08v-5.34c0-2.68-2.18-4.86-4.86-4.86Z"
      />
      <rect fill={color} x="14.81" width="9.73" height="1.08" />
      <path
        fill={color}
        d="M0,4.86v5.44h1.08v-5.44c0-2.09,1.7-3.78,3.78-3.78h5.37V0h-5.37C2.18,0,0,2.18,0,4.86Z"
      />
      <polygon
        fill={color}
        points="21.08 12.43 18.92 12.43 18.92 18.92 12.43 18.92 12.43 21.08 18.92 21.08 18.92 27.57 21.08 27.57 21.08 21.08 27.57 21.08 27.57 18.92 21.08 18.92 21.08 12.43"
      />
    </svg>
  );
};
